import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiGetOneColumn } from '../../../../actions/ColumnActions';
import { wrapDispatch } from '../../../../helpers/action';
import { propStr } from '../../../../helpers/custom-prop-types';
const ColumnContentColumnOne = (props) => {
    const { urlCode } = props;
    const dispatch = useDispatch();
    const column = useSelector((state) => state.column.one[urlCode]);
    useEffect(() => {
        if (column) {
            return;
        }
        const action = apiGetOneColumn(urlCode);
        wrapDispatch(dispatch, action).then();
    }, [dispatch, column, urlCode]);
    if (!column) {
        return null;
    }
    const { title, weightLevel } = column;
    return (_jsx("li", Object.assign({ className: 'column_row' }, { children: _jsx(Link, Object.assign({ to: `/column/${weightLevel}/${urlCode}` }, { children: title })) })));
};
ColumnContentColumnOne.propTypes = {
    urlCode: propStr().isRequired,
};
export default ColumnContentColumnOne;
